import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./Receipt/Main";
import Form from "./Receipt/Form";

// แยกเฉพาะโรงน้ำ
import FormWater from "./Receipt/FormWater";

// Utils
import {
  getDataWithComp,
  getMaxDocNo,
  getMaxDocInvNo,
  getAlert,
} from "../../../utils/SamuiUtils";

import { getReport } from "../../../utils/ReportUtils";
import Navbar from "../../components/Modal/Navbar";

const Bill = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [maxBiNo, setMaxBiNo] = useState();
  console.log(maxBiNo);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "API_0701_SO_H",
        `AND Doc_INV_No IS NOT NULL 
        AND Doc_Status_Paid = '3'
        ORDER BY Doc_Id DESC`
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }

      // หาค่าสูงของ DocNo ใน BL_H สำหรับ BI (ใบวางบิล)
      const maxBi = getMaxDocInvNo(masterList, "RC");
      setMaxBiNo(maxBi);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onPageUpdate = (docNo) => {
    setMaxBiNo(docNo);
    setMode("U");
  };

  return (
    <div>
      <div className="Invoice">
        <div className="wrapper">
          <Navbar />
          <div className="main-panel">
            <div className="container">
              <div className="page-inner">
                {mode === "S" ? (
                  <Main
                    name={"ใบเสร็จรับเงิน"}
                    dataMasterList={dataMasterList}
                    onPageInsert={() => onPageInsert()}
                    onPageUpdate={(docNo) => onPageUpdate(docNo)}
                  />
                ) : (
                  //   <>
                  //     {localStorage.getItem("company") === "1" ? (
                  //       <FormWater
                  //         callInitialize={initialize}
                  //         mode={mode}
                  //         name={"ใบเสร็จรับเงิน"}
                  //         docNo={maxBiNo}
                  //         getReport={getReport}
                  //       />
                  //     ) : (
                  <Form
                    callInitialize={initialize}
                    mode={mode}
                    name={"ใบเสร็จรับเงิน"}
                    docNo={maxBiNo}
                    getReport={getReport}
                  />
                )}
                {/* </>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bill;
